import { computed, shallowRef } from 'vue'
import type { LocalizedMessage } from '@/interfaces/LocalizedMessage'

/** Holds a message thunk so the string is re-translated on each read, following locale switches. */
export const useLocalizedMessage = (): LocalizedMessage => {
  const thunk = shallowRef<(() => string) | null>(null)
  return {
    clear: () => {
      thunk.value = null
    },
    message: computed(() => thunk.value?.() ?? null),
    set: (next) => {
      thunk.value = next
    }
  }
}
